module.exports = function (app) {
    app.factory("MonitoringFactory", [
        "$injector",
        function ($injector) {
            return function (tool) {
                if (!tool || typeof tool !== "object") {
                    console.warn("Invalid tool object provided. Using fallback implementation.");
                    return getFallbackImplementation();
                }

                let activeTool = null;
                for (const key in tool) {
                    if (Object.prototype.hasOwnProperty.call(tool, key) && tool[key] === 'true') {
                        console.log(`Active monitoring tool detected: ${key}`);
                        activeTool = key;
                        break;
                    }
                }

                console.log(`Final ActiveTool: ${activeTool}`);

                if (activeTool && activeTool !== "UnsupportedTool") {
                    try {
                        /**
                         * Monitoring tool's service export name should be exactly same as
                         * monitoringTools constant's key defined in plugins.config.js.
                         * For instance, Datadog is the service name defined in datadog.srv.js
                         * which is defined same way in const monitoringTools of plugins.config.js
                         */
                        return $injector.get(activeTool);
                    } catch (err) {
                        console.error(`Error resolving service for ${activeTool}: ${err.message}`);
                    }
                }

                console.warn("No supported monitoring tool is enabled. Using fallback implementation.");
                return getFallbackImplementation();
            };

            function getFallbackImplementation() {
                return {
                    logAndRethrow: () => {
                        console.warn("Monitoring tool not available: logAndRethrow called");
                    },
                    addPageAction: () => {
                        console.warn("Monitoring tool not available: addPageAction called");
                    },
                    noticeError: () => {
                        console.warn("Monitoring tool not available: noticeError called");
                    },
                    setCustomEventAttribute: () => {
                        console.warn("Monitoring tool not available: setCustomEventAttribute called");
                    },
                };
            }
        },
    ]);
};